module.exports = __webpack_public_path__ + "img/20.ecf7b7f2.jpg";